


























import Vue from 'vue'
import { popNewMessage } from '@/utility/helpers'
export default Vue.extend({
    data() {
        return {
            activeBtn: null
        }
    },
    computed: {
        approachingLimit(): boolean {
            //  Approaching limit is when you have 10% or less of your storage remaining
            //  Formula is (limit - used) being <= 10% of limit
            return this.storageLimit - this.storageUsed <= this.storageLimit * 0.1
        },
        inbox(): number {
            return this.$store.getters.defaultBucketUnreadCount
        },
        navItems(): object[] {
            return [
                {
                    title: `Inbox`,
                    icon: 'mdi-inbox',
                    color: 'primary',
                    link: '/inbox',
                    badge: this.inbox,
                    badgeContent: this.inbox,
                    badgeColor: 'primary'
                },
                {
                    title: 'New Message',
                    icon: 'bi-plus-square-fill',
                    iconColor: 'primary',
                    color: 'primary',
                    callback: () => popNewMessage()
                },
                {
                    title: 'Contacts',
                    icon: 'mdi-account',
                    color: 'primary',
                    link: '/contacts'
                }
            ]
        },
        storageLimit(): number {
            return this.$store.getters.storageLimit
        },
        storageUsed(): number {
            return this.$store.getters.storageUsed
        }
    },
    methods: {
        goToLink(item: any): void {
            //  If this includes a callback instead of a link, do the callback
            if (item.callback) return item.callback()

            //  Route to the link
            if (!this.$route.path.includes(item.link)) this.$router.push(item.link)
        }
    }
})
